<template>
  <div>
    <div class="col-md-4 col-md-offset-2">
        <span class="tooltips hidden-xs" data-container="body" data-placement="right" data-html="true"
        :data-original-title="tooltipCouverture">
            <i class="icon-info"></i>
        </span>
        <span class="tooltips visible-xs" data-container="body" data-placement="top" data-html="true"
        :data-original-title="tooltipCouverture">
            <i class="icon-info"></i>
        </span>
        <div class="portlet light" style="border: 1px solid #C2CAD8; margin-right: 1em;">
            <div>
            <div class="ss-titre text-center">
                <strong>Photo de couverture</strong>&nbsp;-&nbsp;<em class="text-center" style="font-size: 11px;">jpg ou png acceptés uniquement</em>
            </div>
              <v-image-upload
                name="couverture"
                :index="1"
                :ratio="16/9"
                @validated="sendImage"
                @image="addNewImage"
                :oldImage="couverture">
              </v-image-upload>
            </div>
        </div>
    </div>
    <div class="col-md-4">
        <span class="tooltips hidden-xs" data-container="body" data-placement="right" data-html="true"
              :data-original-title="tooltipProfil">
                 <i class="icon-info"></i>
        </span>
        <span class="tooltips visible-xs" data-container="body" data-placement="top" data-html="true"
              :data-original-title="tooltipProfil">
                 <i class="icon-info"></i>
        </span>
        <div class="portlet light" style="border: 1px solid #C2CAD8; margin-right: 1em;">
            <div>
                <div class="ss-titre text-center">
                    <strong>Photo de profil</strong>&nbsp;-&nbsp;<em class="text-center" style="font-size: 11px;">jpg ou png acceptés uniquement</em>
                </div>
                <v-image-upload
                  name="profile"
                  :index="2"
                  :ratio="16/9"
                  @validated="sendImage"
                  @image="addNewImage"
                  :oldImage="profile">
                </v-image-upload>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
export default {

  name: 'UserImagesForm',
  props: {
    oldImages: {
      type: Array,
      default: () => {
        return []
      }
    },
    user: {
      type: Object,
      default: () => {
        return {}
      }
    },
    tooltipCouverture: {
      type: String,
      default: () => {
        return ''
      }
    },
    tooltipProfil: {
      type: String,
      default: () => {
        return ''
      }
    }
  },
  data () {
    return {
      image: new vImageHelper()
    }
  },
  computed: {
    profile() {
      return this.oldImages.find(img=>img.name == 'profile')
    },
    couverture() {
      return this.oldImages.find(img=>img.name == 'couverture')
    }
  },
  methods: {
    addNewImage(event) {
      this.image.add(event)
    },
    async sendImage() {
      this.image.send(`/user/${this.user.id}/image`)
    }
  }
};
</script>

<style lang="css">
</style>
